import React, { useEffect, useState } from "react";
import { Badge, Offcanvas, Table } from "react-bootstrap";
import Moment from "react-moment";
import SplitPane from "react-split-pane";
import { NoDataFoundTable, PageLoader } from "../../../../Components/NoDataFoundTable/NoDataFoundTable";
import { isHTMLIdentifier } from "../../../../utils/universalFunction";

const FieldUpdatedHistory = ({
  Show,
  Hide,
  Title,
  updatedFieldHistory,
  tableRef,
  onMouseDown,
  fieldId,
  formFields,
  historyLoader
}) => {
  const [history, setHistory] = useState([]);
  const [fieldName, setFieldName] = useState("");
  const [showLoader, setShowLoader] = useState(true);
  useEffect(() => {
    setFieldName("")
    setHistory([])
  }, [Show]);

  useEffect(() => {
    setTimeout(() => {
      setShowLoader(false);
    }, 500);
  }, [fieldName]);

  let checkFieldType = formFields?.find(item => item.id === fieldId)?.type === "checkbox"

  return (
    <>
      <Offcanvas show={Show} onHide={Hide} placement="end" style={{ width: '800px' }}>
        <Offcanvas.Header closeButton >
          <Offcanvas.Title>
            {Title}
          </Offcanvas.Title>
        </Offcanvas.Header>
        <Offcanvas.Body className="p-0">
          {updatedFieldHistory?.length === 0 ?
            <NoDataFoundTable MSG={"Field history not found!"} />
            :
            <SplitPane split="vertical" minSize={"35%"} style={{ height: "-webkit-fill-available" }}>
              {historyLoader ? (
                <PageLoader />
              ) : (
                <Table ref={tableRef} className="m-0 custom-table" hover striped>
                  <thead className="position-sticky top-0 z-1">
                    <tr>
                      <th
                        onMouseDown={(e) => onMouseDown(e, 0)}
                        className="text-center"
                        style={{ width: 45 }}
                      >
                        Sr.
                      </th>
                      <th onMouseDown={(e) => onMouseDown(e, 1)}>Field</th>
                      <th onMouseDown={(e) => onMouseDown(e, 2)}>Latest Version</th>
                    </tr>
                  </thead>
                  <tbody>
                    {updatedFieldHistory?.map((item, index) => (
                      <tr
                        className={`CP ${item?.fieldName === fieldName ? "selectedRow" : ""
                          }`}
                        onClick={() => { setHistory(item?.history || []); setFieldName(item?.fieldName); setShowLoader(fieldName === item?.fieldName ? false : true) }}
                        key={index}
                      >
                        <td className="text-center">{index + 1}</td>
                        <td>
                          <>
                            {isHTMLIdentifier(item?.fieldLabel || "") ? (
                              <span
                                dangerouslySetInnerHTML={{
                                  __html: item?.fieldLabel,
                                }}
                              />
                            ) : (
                              item?.fieldLabel
                            )}{" "}
                            ({item?.fieldName})
                          </>
                        </td>
                        <td>{item?.version}</td>
                      </tr>
                    ))}
                  </tbody>
                </Table>
              )}
              {showLoader ? (
                <PageLoader />
              ) : (history?.length > 0 ? (
                <Table ref={tableRef} className="m-0 custom-table" hover striped>
                  <thead className="position-sticky top-0 z-1">
                    <tr>
                      <th style={{ width: 60 }} onMouseDown={(e) => onMouseDown(e, 0)}>Version</th>
                      <th onMouseDown={(e) => onMouseDown(e, 1)}>Field Value</th>
                      <th style={{ width: 100 }} onMouseDown={(e) => onMouseDown(e, 2)}>User Id</th>
                      <th style={{ width: 130 }} onMouseDown={(e) => onMouseDown(e, 3)}>Date | Time</th>
                    </tr>
                  </thead>
                  <tbody>
                    {history?.map((element, index) => (
                      <tr key={index}>
                        <td>{element?.version}</td>
                        <td>
                          {checkFieldType ? (
                            (element?.fieldValue || "")
                              .split(", ")
                              .map((item, index) => (
                                <React.Fragment key={index}>
                                  {item.startsWith("https://") ? (
                                    <Badge
                                      onClick={() =>
                                        window.open(element.fieldValue, "_blank", "noopener,noreferrer")
                                      }
                                      bg="primary-subtle" className="CP text-primary" style={{ borderRadius: 3, fontSize: 10 }}>
                                      View File
                                    </Badge>
                                  ) : (
                                    item
                                  )}
                                  ,
                                  <br />
                                </React.Fragment>
                              ))
                          ) : element?.fieldValue?.startsWith("https://") ? (
                            <Badge
                              onClick={() =>
                                window.open(element.fieldValue, "_blank", "noopener,noreferrer")
                              }
                              bg="primary-subtle" className="CP text-primary" style={{ borderRadius: 3, fontSize: 10 }}>
                              View File
                            </Badge>
                          ) : (
                            element?.fieldValue
                          )}
                        </td>
                        <td>{element?.createdBy}</td>
                        <td>
                          <Moment format="DD MMM YYYY | HH:mm" withTitle>
                            {element.createdAt}
                          </Moment>
                        </td>
                      </tr>
                    ))}
                  </tbody>
                </Table>
              ) : (
                <div className="hstack justify-content-center h-100">
                  <div> Please Select Any Field... </div>
                </div>
              ))}
            </SplitPane>
          }
        </Offcanvas.Body>
      </Offcanvas>
    </>
  );
};

export default FieldUpdatedHistory;
